/* ============================================================
   Free Shipping Progress Bar — live updater
   Theme: Flex (Out of the Sandbox) | CornerCart replacement

   Keeps every [data-fsb] bar (cart page + ajax cart drawer)
   in sync with the live cart:
     1. Intercepts fetch/XHR calls to /cart/add, /cart/change,
        /cart/update, /cart/clear and re-reads /cart.js after.
     2. Watches the DOM for re-rendered drawer content (the Flex
        ajax cart re-stamps its Handlebars template on every
        update) and re-applies the latest totals.
     3. Listens for the theme's own ajax-cart jQuery events
        when available.

   TIER1 / TIER2 are in cents and MUST match fsb_tier1 /
   fsb_tier2 in snippets/free-shipping-bar.liquid.
   ============================================================ */
(function () {
  'use strict';

  var TIER1 = 3000;   /* $30  free standard shipping */
  var TIER2 = 10000;  /* $100 free express shipping  */
  var M1 = 45;        /* first milestone position, % of bar */

  var lastTotal = null;
  var refreshTimer = null;

  /* ---------- money formatting ---------- */
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var commaDecimals = withDecimals.replace(/,/g, ' ').replace(/\./g, ',').replace(/ /g, '.');

    if (format && format.indexOf('{{') !== -1) {
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, commaDecimals)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
    }
    return '$' + withDecimals;
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* ---------- state / rendering ---------- */
  function stateFor(total, t1, t2, m1) {
    var pct;
    if (total >= t2) {
      pct = 100;
    } else if (total >= t1) {
      pct = m1 + ((total - t1) * (100 - m1)) / (t2 - t1);
    } else {
      pct = (total * m1) / t1;
    }
    return { pct: Math.max(0, Math.min(100, pct)), t1: total >= t1, t2: total >= t2 };
  }

  function updateBar(el, total) {
    var t1 = parseInt(el.getAttribute('data-fsb-tier1'), 10) || TIER1;
    var t2 = parseInt(el.getAttribute('data-fsb-tier2'), 10) || TIER2;
    var m1 = parseInt(el.getAttribute('data-fsb-m1'), 10) || M1;
    var format = el.getAttribute('data-fsb-money-format') || '';
    var s = stateFor(total, t1, t2, m1);

    var fill = el.querySelector('[data-fsb-fill]');
    if (fill) fill.style.width = s.pct.toFixed(1) + '%';

    var track = el.querySelector('.fsb__track');
    if (track) track.setAttribute('aria-valuenow', Math.round(s.pct));

    el.classList.toggle('fsb--t1', s.t1);
    el.classList.toggle('fsb--t2', s.t2);

    var msg = el.querySelector('[data-fsb-message]');
    if (msg) {
      if (s.t2) {
        msg.innerHTML = 'You’ve unlocked <strong>free express shipping!</strong>';
      } else if (s.t1) {
        msg.innerHTML = 'Free standard shipping unlocked!<br>Add <strong>' +
          escapeHtml(formatMoney(t2 - total, format)) + '</strong> more to get free express shipping';
      } else {
        msg.innerHTML = 'Add <strong>' +
          escapeHtml(formatMoney(t1 - total, format)) + '</strong> more to get free standard shipping';
      }
    }
  }

  function updateAll(total) {
    lastTotal = total;
    var bars = document.querySelectorAll('[data-fsb]');
    for (var i = 0; i < bars.length; i++) updateBar(bars[i], total);
  }

  /* ---------- cart polling ---------- */
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && typeof cart.total_price === 'number') updateAll(cart.total_price);
        })
        .catch(function () { /* network hiccup — keep last state */ });
    }, 150);
  }

  var CART_URL = /\/cart\/(add|change|update|clear)/;

  /* ---------- hook: fetch ---------- */
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var p = origFetch.apply(this, args);
      try {
        var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        if (CART_URL.test(url)) p.then(function (res) { refresh(); return res; });
      } catch (e) { /* noop */ }
      return p;
    };
  }

  /* ---------- hook: XMLHttpRequest (covers jQuery ajax) ---------- */
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._fsbUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr._fsbUrl && CART_URL.test(String(xhr._fsbUrl))) {
        xhr.addEventListener('load', function () { refresh(); });
      }
      return origSend.apply(this, arguments);
    };
  }

  /* ---------- hook: theme ajax-cart events (if jQuery present) ---------- */
  function bindThemeEvents() {
    if (!window.jQuery) return;
    try {
      window.jQuery(document.body).on(
        'afterCartLoad.ajaxCart ajaxCart.afterCartLoad cart.requestComplete cartUpdated',
        function () { refresh(); }
      );
    } catch (e) { /* noop */ }
  }

  /* ---------- hook: drawer re-renders ---------- */
  function watchDom() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      if (lastTotal === null) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.hasAttribute && node.hasAttribute('data-fsb')) {
            updateBar(node, lastTotal);
          } else if (node.querySelectorAll) {
            var bars = node.querySelectorAll('[data-fsb]');
            for (var k = 0; k < bars.length; k++) updateBar(bars[k], lastTotal);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- init ---------- */
  function init() {
    bindThemeEvents();
    watchDom();
    refresh(); /* sync once on load in case of cached page */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
